import { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import { TenantIdContext } from "@touchtech/web-tenant-id-provider";

import { TranslationContext } from "@is/constants";
import { useStartNewSearch, useTenant } from "@is/hooks";

type Props = {
  onLogoClick?: () => void;
};

const useManageFooter = ({ onLogoClick }: Props) => {
  const { t } = useTranslation(TranslationContext.General);

  const { restartSearch } = useStartNewSearch();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const [tenantId] = useContext(TenantIdContext);

  const { tenant } = useTenant(tenantId);

  const handleLogoClick = useCallback(() => {
    onLogoClick && onLogoClick();
  }, [onLogoClick]);

  const handleRestartClick = useCallback(async () => {
    setShowConfirmationModal(() => false);
    await restartSearch();
  }, [restartSearch]);

  const handleOpenModal = useCallback(() => {
    setShowConfirmationModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowConfirmationModal(false);
  }, []);

  return {
    t,
    tenant,
    handleLogoClick,
    handleRestartClick,
    handleOpenModal,
    handleCloseModal,
    showConfirmationModal,
  };
};

export default useManageFooter;
